export const useStyles = () => {
    return {
        form: {
            width: '100%',
            maxWidth: '800px',
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
        center: {
            display: 'flex',
            justifyContent: 'center'
        },
        container: {
            padding: 3
        },
        footer: {
            display: 'flex',
            justifyContent: 'end',
            marginTop:'24px'
        }
    }
}